// $('.is-more-category').click(function () {
//   if ($(this).hasClass('l-sub-category-contents__link')) {
//     $(this).parent().toggleClass('is-category-open');
//   }
// });

// $('.l-sub-category-title').click(function () {
//   $(this).parent().toggleClass('is-open');
//   // if ($(this).hasClass('l-sub-category-contents__link')) {
//   // }
// });

import isMobile from '../../plugins/is-mobile.js';

if (isMobile(768)) {
  if ($('.page-hiroba').length) {
    $('.is-block-hiroba').addClass('is-sp-open');
    console.log('hiroba');
  } else if ($('.page-ichiba').length) {
    $('.is-block-ichiba').addClass('is-sp-open');
    console.log('ichiba');
  }
}

$('.l-sub-list-detail__action').click(function () {
  $(this).parent().parent().toggleClass('is-category-open');
});

$('.l-sub-list-title').click(function () {
  if (isMobile(768)) {
    $(this).parent().toggleClass('is-sp-open');

    if (!($(this).parent().hasClass('is-sp-open'))) {
      $(this).parent().addClass('is-sp-close');
    } else {
      $(this).parent().removeClass('is-sp-close');
    }
  }
});
